import BRAND from '@/brand';

// Ordmaerket. hentpost saetter det med tekst; DigitalBox har et rigtigt logo,
// hvor "Box" er outlines og den teal kasse har et hak i hoejre hjoerne — det
// kan ikke gengives med tekst alene.
//
// SVG'en er inline frem for <img>, af to grunde: "Digital" er levende tekst i
// Stack Sans Notch og henter kun fonten naar den staar i dokumentet, og
// fill="currentColor" lader den skifte med lyst/moerkt tema. En <img> ville
// vaere sort paa sort i moerkt tema.
//
// Hoejden er 1em, saa maerket skalerer med den omgivende tekststoerrelse
// praecis som tekst-ordmaerket gjorde.

function DigitalBoxMark() {
    return (
        <svg
            viewBox="0 0 1553.83 380.35"
            role="img"
            aria-label="DigitalBox"
            style={{
                height: '1em', width: 'auto', maxWidth: '100%',
                display: 'inline-block', verticalAlign: '-0.14em',
            }}
        >
            <text
                transform="translate(-15.11 307.12)"
                fill="currentColor"
                style={{
                    fontFamily: "'Stack Sans Notch', system-ui, sans-serif",
                    fontSize: '328.17px',
                    fontWeight: 500,
                    // Skriften er variabel. fontWeight alene er nok i browsere,
                    // men aksen saettes eksplicit saa maerket ikke falder
                    // tilbage til Regular i renderere der ignorerer vaegten —
                    // logoet skal have samme tykkelse alle steder.
                    fontVariationSettings: "'wght' 500",
                }}
            >
                <tspan x="0" y="0">D</tspan>
                <tspan x="221.51" y="0">i</tspan>
                <tspan x="307.82" y="0">g</tspan>
                <tspan x="511.61" y="0">i</tspan>
                <tspan x="599.89" y="0">t</tspan>
                <tspan x="719.01" y="0">a</tspan>
                <tspan x="905.08" y="0">l</tspan>
            </text>
            <g fill="#1abc9c">
                <path d="M994.7,60.99h51.85c16.62,0,31.78,2.06,45.45,6.16,13.67,4.11,24.56,11.32,32.65,21.64,8.09,10.32,12.14,24.75,12.14,43.27,0,7.98-1.48,16.07-4.43,24.27-2.95,8.21-7.6,15.13-13.95,20.76-1.45,1.28-3.02,2.42-4.68,3.43,2.62,1.08,5.17,2.32,7.64,3.78,8.53,5.05,15.31,11.85,20.35,20.4,5.03,8.57,7.55,18.59,7.55,30.08,0,18.53-4.05,33.07-12.14,43.62-8.1,10.55-18.98,18-32.65,22.34-13.67,4.34-28.83,6.51-45.45,6.51h-71.53v61.57h563.51V41.57l-75.12.24.24-41.81h-488.64v60.99h7.21ZM1400.99,123.7l34.13,53.54,34.13-53.54h47.91l-58.09,91.12,59.07,92.66h-47.91l-35.11-55.08-35.11,55.08h-47.91l59.07-92.66-58.09-91.12h47.91ZM1176.68,165.38c7.76-14.66,18.71-26.14,32.82-34.46,14.11-8.31,30.68-12.47,49.72-12.47s35.22,4.16,49.23,12.47c14,8.32,24.88,19.8,32.65,34.46,7.76,14.66,11.65,31.5,11.65,50.54s-3.89,35.56-11.65,50.21c-7.77,14.66-18.65,26.09-32.65,34.29-14.01,8.2-30.52,12.31-49.55,12.31s-35.28-4.1-49.39-12.31c-14.11-8.2-25.05-19.63-32.82-34.29-7.77-14.65-11.65-31.39-11.65-50.21s3.88-35.88,11.65-50.54Z" />
                <path d="M1230.66,267.94c7.66,5.14,17.17,7.71,28.55,7.71s20.56-2.57,28.22-7.71c7.66-5.14,13.46-12.25,17.39-21.33,3.94-9.08,5.91-19.31,5.91-30.68s-1.97-21.99-5.91-31.18c-3.94-9.19-9.74-16.35-17.39-21.49-7.66-5.14-17.06-7.71-28.22-7.71s-20.9,2.57-28.55,7.71c-7.66,5.14-13.46,12.31-17.39,21.49-3.94,9.19-5.91,19.58-5.91,31.18s1.97,21.61,5.91,30.68c3.94,9.08,9.73,16.19,17.39,21.33Z" />
                <path d="M1083.31,265.4c7-1.87,12.47-5.22,16.41-10.03,3.94-4.8,5.91-11.66,5.91-20.58s-1.97-15.36-5.91-20.05c-3.94-4.69-9.41-7.92-16.41-9.67-7.01-1.76-14.99-2.64-23.96-2.64h-40.69v65.79h40.36c9.19,0,17.28-.93,24.29-2.81Z" />
                <path d="M1071.17,161.09c7-1.52,12.47-4.57,16.41-9.15,3.94-4.57,5.91-11.31,5.91-20.23s-1.92-15.3-5.74-19.88c-3.83-4.57-9.24-7.68-16.24-9.32-7-1.64-15.32-2.46-24.94-2.46h-27.89v63.33h28.55c8.97,0,16.95-.76,23.96-2.29Z" />
            </g>
        </svg>
    );
}

export default function Wordmark() {
    // Nye brands uden eget maerke falder tilbage til tekst-ordmaerket fra
    // brandprofilen — de behoever ikke roere denne fil.
    if (BRAND.key === 'digitalbox') return <DigitalBoxMark />;

    return (
        <>
            {BRAND.wordmark.lead}
            <span className="text-brand-500">{BRAND.wordmark.tail}</span>
        </>
    );
}
